"use client";

import { IlluDotGrid } from "@/app/(components)/generics/Illustrations/IlluDotGrid/IlluDotGrid";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import homeStyles from "../../Home.module.css";
import { HOW_IT_WORKS_BLOCKS } from "./HowItWorks.logic";
import styles from "./HowItWorks.module.css";
import HowItWorksBlock from "./HowItWorksBlock";

export default function HowItWorks() {
  const T = useT();

  return (
    <div className={styles.band}>
      <IlluDotGrid />

      <div className={styles.container}>
        <div className={homeStyles.titles}>
          <span className={homeStyles.supTitle}>{T(TKey.HOME_MEIDLY_HOW_SUP_TITLE)}</span>
          <h2 className={homeStyles.statement}>{T(TKey.HOME_MEIDLY_HOW_TITLE)}</h2>
        </div>

        <div className={styles.blocks}>
          {HOW_IT_WORKS_BLOCKS.map((block, index) => (
            <HowItWorksBlock
              key={block.mock}
              block={block}
              step={index + 1}
              isReversed={index % 2 === 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
